import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Label from '../../gdc-components-atoms-label';
import InputText from '../../gdc-components-atoms-input-text';

import './styles.css';

export class Input extends Component {
    handleOnChangeValue = ({ target: { value } }) => {
        this.props.handleOnChangeValue(value);
    }

    render() {
        const {
            inputId,
            inputValue,
            labelId,
            labelValue,
            maxLength,
            placeholder,
            mandatory,
            tabIndex,
            isError
        } = this.props;

        let type = this.props.inputType === 'password' ? 'password' : 'text';

        let inputClass = isError ? 'form-control striped-input input-error' : 'form-control striped-input';

        return (
            <div>
                <Label id={labelId} className="label-input">{labelValue}</Label>
                <InputText
                    id={inputId}
                    type={type}
                    mandatory={mandatory}
                    maxLength={maxLength}
                    className={inputClass}
                    placeholder={placeholder}
                    value={inputValue}
                    tabIndex={tabIndex}
                    onKeyDown={this.handleOnKeydown}
                    onChange={this.handleOnChangeValue}
                    onKeyPress={this.props.handleOnKeyPress} />
            </div>
        );
    }
}

Input.propTypes = {
    inputType: PropTypes.string,
    inputId: PropTypes.string,
    inputValue: PropTypes.string,
    labelId: PropTypes.string,
    labelValue: PropTypes.string,
    maxLength: PropTypes.string,
    placeholder: PropTypes.string,
    mandatory: PropTypes.bool,
    isError: PropTypes.bool,
    handleOnChangeValue: PropTypes.func,
    handleOnKeyPress: PropTypes.func
};

export default Input;


// WEBPACK FOOTER //
// ./src/components/common/input/index.js